export default __webpack_public_path__ + "static/media/QIANA BLUE.f32f3494.jpg";